import "./App.css";
import { BrowserRouter } from "react-router-dom";
import OverView from "./pages/overView";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

function App() {
  const headers = {
    "Content-Type": "application/json",
    "Custom-Header": "value",
  };
  const id = "12345";
  const accessToken = "your-access-token";
  const apiUrl = "http://192.168.29.28:8000/api/report/get-individual-report";

  const [FData, setFData] = useState<any>({});

  useEffect(() => {
    const handleParentMessage = (event: any) => {
      console.log("Message received:", event.data);
      console.log("Message origin:", event.origin);

      if (event.origin !== "http://localhost:3000") return;

      setFData(event.data);
    };

    window.addEventListener("message", handleParentMessage);

    return () => {
      window.removeEventListener("message", handleParentMessage);
    };
  }, []);

  return (
    <BrowserRouter>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h3">Report Module</Typography>
        <OverView
          headers={FData?.headers}
          reportId={FData?.id}
          accessToken={FData?.accessToken}
          apiUrl={FData?.apiUrl}
        />
      </Box>
    </BrowserRouter>
  );
}

export default App;
